// extracted by mini-css-extract-plugin
export default {"root":"PageAudits_root__wcrZE","top":"PageAudits_top__7nq9i"};